import {
  Breadcrumb,
  Row,
  Col,
  Button,
  Modal
} from "antd";
import "../AccountListPage.css"
import { IconUnbanned } from "../../../assets/icons/icons";

import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import noImage from "../../../assets/images/no-image.png";
import { ACCOUNT_LIST_CONSTANT } from "../../../constant/accountlist.constant";
import { modalCustom } from "../../modal/modalCustom";
import accoutListService from "../../../service/accoutListService";
import { useSelector } from "react-redux";
import { SIDEBAR_CONSTANT } from "../../../constant/sidebar.constant";
import { ROUTER_CONSTANT } from "../../../constant/router.constant";

const AccountListPageForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = useSelector((state) => state.loginData.token);
  const baseUrl = ROUTER_CONSTANT.HOME + ROUTER_CONSTANT.ACCOUNT_LIST;
  const [detailImage, setDetailImage] = useState(noImage);
  const [dataDetail, setDataDetail] = useState(
    {
      userId: "",
      firstName: "-",
      lastName: "-",
      email: "-",
      nik: "-",
      phoneNumber: "-",
      additionalInfo: "-",
      status: "-",
    }
  );

  const buttonFormCancel = () => {
    return (
      <Button className="form-button-footer-style" key="cancel" onClick={() => navigate(baseUrl)}>
        Cancel
      </Button>
    )
  }

  const buttonFormUnbanned = (data) => {
    return (
      <>
        <Button className="form-button-footer-style" key="unbanned"
          onClick={() => handleUnbannedAccount(dataDetail)}
          icon={<IconUnbanned style={{ marginRight: "5px", fontSize: "40px" }} />} type="primary">
          Unbanned
        </Button>
      </>
    )
  }

  const okSuccessFunction = () => {
    navigate(baseUrl);
  }

  const okFailedFunction = () => {
    // TODO: Handle failed unbanned function
  }

  const handleModalError = () => {
    modalCustom(
      ACCOUNT_LIST_CONSTANT.MODAL_FAILED_TITLE_UNBANNED_ACCOUNT,
      ACCOUNT_LIST_CONSTANT.MODAL_FAILED_CONTENT_UNBANNED_ACCOUNT,
      ACCOUNT_LIST_CONSTANT.MODAL_FAILED_OK_BUTTON_UNBANNED_ACCOUNT,
      okFailedFunction,
      "failed"
    );
  }

  const handleUnbannedAccount = (dataAccount) => {
    Modal.confirm({
      title: ACCOUNT_LIST_CONSTANT.MODAL_TITLE_UNBANNED_ACCOUNT,
      centered: true,
      okText: ACCOUNT_LIST_CONSTANT.MODAL_OK_BUTTON_UNBANNED_ACCOUNT,
      cancelText: ACCOUNT_LIST_CONSTANT.MODAL_CANCEL_BUTTON_UNBANNED_ACCOUNT,
      content: ACCOUNT_LIST_CONSTANT.MODAL_CONTENT_UNBANNED_ACCOUNT,
      icon: null,
      onOk() {
        let params = {
          NextokenID: dataAccount.userId,
          Status: "A"
        }
        accoutListService.unbannedAccount(token, params).then((response) => {
          if (response.data.nexsoft.payload.status.success) {
            modalCustom(
              ACCOUNT_LIST_CONSTANT.MODAL_SUCCESS_TITLE_UNBANNED_ACCOUNT,
              ACCOUNT_LIST_CONSTANT.MODAL_SUCCESS_CONTENT_UNBANNED_ACCOUNT,
              ACCOUNT_LIST_CONSTANT.MODAL_SUCCESS_OK_BUTTON_UNBANNED_ACCOUNT,
              okSuccessFunction,
              "success"
            );
          } else {
            handleModalError();
          }
        }).catch((error) => {
          handleModalError();
        });
      }
    });
  }

  useEffect(() => {
    if (!location.state) {
      navigate(baseUrl);
    }

    if (location.state) {
      const data = location.state;
      const stateData = {
        userId: data.nextoken_user_id,
        firstName: data.first_name,
        lastName: data.last_name,
        email: data.email,
        nik: data.ktp,
        phoneNumber: data.phone,
        additionalInfo: data.additional_info,
        status: data.status,
      }

      setDataDetail(stateData);
      if (data.url_ktp !== null && data.url_ktp !== "" && data.url_ktp !== undefined && data.url_ktp !== "-") {
        setDetailImage(data.url_ktp);
      }
    }

  }, [location, navigate, baseUrl]);

  return (
    <>
      <Row>
        <Breadcrumb separator=">">
          <Breadcrumb.Item>{SIDEBAR_CONSTANT.MENU_SETTING_LIST}</Breadcrumb.Item>
          <Breadcrumb.Item
            onClick={() => navigate(baseUrl)}
            style={{ cursor: "pointer" }}
          >
            {ACCOUNT_LIST_CONSTANT.MENU_USER_ACCOUNT_LIST}
          </Breadcrumb.Item>
          <Breadcrumb.Item>{dataDetail.status !== "A" ? ACCOUNT_LIST_CONSTANT.MENU_UNBANNED_USER_ACCOUNT_LIST : ACCOUNT_LIST_CONSTANT.TITLE_FORM_DETAIL_USER_ACCOUNT_LIST}</Breadcrumb.Item>
        </Breadcrumb>
      </Row>

      <Row className="accountlist-title">
        <MdOutlineArrowBackIosNew
          onClick={() => navigate(baseUrl)}
          className="arrow-back-form-title" />
        {dataDetail.status !== "A" ? ACCOUNT_LIST_CONSTANT.MENU_UNBANNED_USER_ACCOUNT_LIST : ACCOUNT_LIST_CONSTANT.TITLE_FORM_DETAIL_USER_ACCOUNT_LIST}
      </Row>

      <br />

      <Row className="card-white-box-container">
        <Col xs md={24}>

          <div className="card-white-box">

            <Row className="account-list-card-title">
              {ACCOUNT_LIST_CONSTANT.TITLE_FORM_DETAIL_USER_ACCOUNT_LIST}
            </Row>
            <br />

            <Row>

              <Col span={8}>
                <div className="image-portrait-container">
                  <img alt="User KTP" className="image-ktp-style" src={detailImage}>
                  </img>
                </div>
              </Col>

              <Col span={16}>
                <Row className="form-label-title">
                  First Name
                </Row>
                <Row className="form-label-content">
                  {dataDetail.firstName}
                </Row>

                <Row className="form-label-title">
                  Last Name
                </Row>
                <Row className="form-label-content">
                  {dataDetail.lastName}
                </Row>

                <Row className="form-label-title">
                  E-mail
                </Row>
                <Row className="form-label-content">
                  {dataDetail.email}
                </Row>

                <Row className="form-label-title">
                  Nomor Induk Kependudukan ( NIK )
                </Row>
                <Row className="form-label-content">
                  {dataDetail.nik}
                </Row>

                <Row className="form-label-title">
                  Phone number
                </Row>
                <Row className="form-label-content">
                  {dataDetail.phoneNumber}
                </Row>

                <Row className="form-label-title">
                  Additional Info
                </Row>
                <Row className="form-label-content">
                  {dataDetail.additionalInfo}
                </Row>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      <Row justify="end">
        <div className="form-button-footer">
          {buttonFormCancel()}
          {dataDetail.status !== "A" && buttonFormUnbanned()}
        </div>
      </Row>
    </>
  )
}

export default AccountListPageForm;